import {Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {LaasOption} from 'src/app/core/models/laas-option';
import {deepCopy, isNullOrEmpty} from 'src/app/core/utils/common-functions';
import {SessionBaseComponent} from 'src/app/shared/components/session.base.component';
import {TaskLogicServiceService} from '../../services/task-logic-service.service';
import {LaasOptionAdvance} from '../../../../core/models/laas-option-advance';
import {ReceivingInstructionService} from '../../services/receiving-instruction.service';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'laas-receiving-instruction-batch-update',
  templateUrl: './receiving-instruction-batch-update.component.html',
  styleUrls: ['./receiving-instruction-batch-update.component.scss']
})
export class ReceivingInstructionBatchUpdateComponent extends SessionBaseComponent implements OnInit {

  @Output() visibleChange = new EventEmitter<any>();
  @Output() updateReceivingInstruction = new EventEmitter<any>();
  @Input() advanceTaskListObject: any;
  @Input() lockTypeOptions: LaasOption[]=[];
  @Input() lockCodeOptions: LaasOption[]=[];
  @Input() lockReasonOptions: LaasOption[]=[];
  @Input() receivingTaskCodeGroupLogic:Map<string, any[]> = new Map();

  advanceValues: any = {};
  advanceTaskCodeFieldType: Map<string, any[]> = new Map();
  advanceTaskCode: Map<string, string[]> = new Map();
  advanceTaskForFrontEnd:Map<string, any[]> = new Map();

  isVisible: boolean;
  canEditTaskRemark: boolean;

  @Input() receivingTaskOptions: LaasOptionAdvance[];
  @Input() openType?: string;
  taskCode?: string[];
  taskRemark?: string;
  @Input() consigneeKeyOptions: LaasOption[];
  @Input() vendorNumberOptions: LaasOption[];
  @Input() selectedAdNoList: string[] = [];

  invalidStatesTask: { [key: string]: { [field: string]: boolean } } = {};

  // 上傳模式相關
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  activeTabIndex: number = 0; // 0: 手動維護, 1: 上傳檔案
  selectedFile: File | null = null;
  selectedFileName: string = '';
  isUploading: boolean = false;

  constructor(
    injector: Injector,
    private taskLogicServiceService: TaskLogicServiceService,
    private receivingInstructionService: ReceivingInstructionService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    super(injector);

    this.isVisible = false;
    this.canEditTaskRemark = false;

    this.receivingTaskOptions = [];
    this.consigneeKeyOptions = [];
    this.vendorNumberOptions = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.taskLogicServiceService.advanceTaskForFrontEnd().subscribe({
      next: result => {
        Object.entries(result).forEach(([key, value]: any) => {
            this.advanceTaskForFrontEnd.set(key, value);
        });
      }
    });
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }

  taskCodeOptionCahange() {
    console.log(this.taskCode);
    if (this.taskCode?.length! == 0 || isNullOrEmpty(this.taskCode)) {
      this.canEditTaskRemark = false;
      this.taskRemark = undefined;
      this.advanceTaskCodeFieldType.clear();
      this.receivingTaskOptions = this.checkOptionLockStatus(this.receivingTaskOptions!,this.taskCode);
    } else {
      this.canEditTaskRemark = true;
      this.receivingTaskOptions = this.checkOptionLockStatus(this.receivingTaskOptions!,this.taskCode);
      this.initNgModel(this.taskCode)
    }
  }

  updateReceivingInstructionClick(): void {
    if (this.checkInvalidStatesTask(this.advanceValues)){
      return;
    }

    let receivingInstruction = {
      openType:this.openType,
      taskCode: this.taskCode,
      taskRemark: this.taskRemark,
      advanceTask:deepCopy(this.advanceValues),
    };
    this.updateReceivingInstruction.emit(receivingInstruction);
    this.taskCode = undefined;
    this.taskRemark = undefined;
    this.canEditTaskRemark = false;
    this.openType = '';

    this.advanceValues = {};
    this.advanceTaskCodeFieldType.clear();
    this.advanceTaskCode.clear();
  }

  assertType(task: any) {
    return String(task);
  }

  checkFieldType(fieldType: any, field: string) {
    return fieldType == field;
  }

  checkOptionsListSize(fieldName: any):boolean {
    switch (fieldName) {
      case 'lockCode':
        return true;
      default:
        return false;
    }
  }

  checkOptionsList(fieldName: any):any[] {
    switch (fieldName) {
      case 'lockType':
        return this.lockTypeOptions;
      case 'lockCode':
        return this.lockCodeOptions;
      case 'lockReason':
        return this.lockReasonOptions;
      default:
        return [];
    }
  }

  checkAdvanceTaskCodeList(taskCode: string, propTaskCode: string[]) {
    return propTaskCode?.some((prop) => prop == taskCode);
  }

  initNgModel(taskCodeList: any) {
    this.advanceTaskCodeFieldType.clear();
    this.advanceTaskCode.clear();

    for (const [key, value] of this.advanceTaskForFrontEnd) {
      if (!isNullOrEmpty(taskCodeList) && this.checkAdvanceTaskCodeList(key, taskCodeList)) {
        this.advanceTaskCodeFieldType.set(key, value);
      }
    }

    for (const [key, value] of this.advanceTaskListObject) {
      if (!isNullOrEmpty(taskCodeList) && this.checkAdvanceTaskCodeList(key, taskCodeList) && !this.advanceTaskCode.has(key)) {
        this.advanceTaskCode.set(key, value);
      }
    }
    if (this.advanceTaskCode.size != 0) {
      this.advanceValues = {};
      this.advanceTaskCode.forEach((field, task) => {
        const valueObject: any = {};

        field.forEach(property => {
          valueObject[property] = null;
        });
        this.advanceValues[task] = valueObject;
      });
    }

  }

  checkOptionLockStatus( optionAdvances: LaasOptionAdvance[], taskCode: any): LaasOptionAdvance[] {
    const filterLockGroupMap = new Map<string, string[]>();
    const optionAdvancesCheck = optionAdvances;
    for (const [key, value] of this.receivingTaskCodeGroupLogic) {
      const filteredValue = value.filter(item => taskCode.includes(item));
      if (filteredValue.length > 0) {
        filterLockGroupMap.set(key, value);
      }
    }


    const groupValues: string[] = Array.from(filterLockGroupMap.values()).reduce((acc, curr) => acc.concat(curr), []);
    optionAdvancesCheck.forEach((option: any) => {
      const selectTaskCodeIsAdvanceTask: boolean = !isNullOrEmpty(taskCode) && groupValues.some((lockTask) => taskCode.includes(lockTask));
      if (!isNullOrEmpty(taskCode) && taskCode.length > 0 && selectTaskCodeIsAdvanceTask) {
        const isLock = groupValues.includes(option.value);
        option.isDisabled = isLock && !taskCode.includes(option.value);
      } else {
        option.isDisabled = false;
      }
    });

    return optionAdvancesCheck;
  }

  initComponent() {
    this.canEditTaskRemark = false;
    this.taskRemark = undefined;
    this.advanceTaskCodeFieldType.clear();
    this.taskCode=[];
    this.activeTabIndex = 0;
    this.resetUploadState();
  }

  initOption(fieldName: any):void {
    switch (fieldName) {
      case 'Customer':
        this.lockCodeOptions = this.consigneeKeyOptions;
        break;
      case 'Vendor':
        this.lockCodeOptions = this.vendorNumberOptions;
        break;
      default:
        this.lockCodeOptions=[];
    }
  }

  checkInvalidStatesTask(advanceValues: Record<string, Record<string, any>>): boolean {
    const validStatesTask = ['N03-5', 'N03-7'];

    this.invalidStatesTask = validStatesTask.reduce((acc, key) => {
      if (key in advanceValues) {
        const fieldInvalid = Object.entries(advanceValues[key]).reduce((fieldAcc, [field, value]) => {
          if (field === 'otherReasonDesc') {
            if (advanceValues[key]['lockReason'] === '7' && isNullOrEmpty(value)) {
              fieldAcc[field] = true;
            }
          } else if (isNullOrEmpty(value)) {
            fieldAcc[field] = true;
          }
          return fieldAcc;
        }, {} as Record<string, boolean>);

        if (Object.keys(fieldInvalid).length > 0) {
          acc[key] = fieldInvalid;
        }
      }
      return acc;
    }, {} as Record<string, Record<string, boolean>>);

    return Object.keys(this.invalidStatesTask).length > 0;
  }

  checkInvalidStates(task: string, field: any) {
    return this.invalidStatesTask[task]?.[field];
  }

  // 是否顯示模式切換 (僅當 taskCode 為 ['N03-5'] 時顯示)
  get showModeToggle(): boolean {
    return this.taskCode?.length === 1 && this.taskCode[0] === 'N03-5';
  }

  // Tab 切換處理
  onTabChange(event: any): void {
    if (event.index === 1) {
      // 切換到上傳檔案 Tab 時清空選擇的檔案
      this.selectedFile = null;
      this.selectedFileName = '';
    }
  }

  // 檔案選擇處理
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.selectedFileName = this.selectedFile.name;
    }
  }

  // 下載範本
  downloadTemplate(): void {
    this.receivingInstructionService.downloadBatchN035Template().subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'BatchN035TaskTemplate.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Download template error:', err);
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('Common.Toast.Error'),
          detail: this.translate.instant('ReceivingInstruction.BatchUpdate.DownloadTemplateFail')
        });
      }
    });
  }

  // 上傳檔案
  uploadFile(): void {
    if (!this.selectedFile) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('Common.Toast.Warn'),
        detail: this.translate.instant('ReceivingInstruction.BatchUpdate.NoFileSelected')
      });
      return;
    }

    if (this.selectedAdNoList.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('Common.Toast.Warn'),
        detail: this.translate.instant('ReceivingInstruction.BatchUpdate.NoAdNoSelected')
      });
      return;
    }

    this.isUploading = true;
    this.receivingInstructionService.uploadBatchN035Task(this.selectedFile, this.selectedAdNoList, this.taskRemark || '').subscribe({
      next: (response) => {
        this.resetUploadState();
        const contentType = response.headers.get('Content-Type') || '';
        const hasErrorFile = response.body && response.body.size > 0 &&
          contentType.includes('spreadsheetml');

        if (hasErrorFile) {
          // 後端回傳含錯誤訊息的 Excel，自動下載
          const blob = response.body as Blob;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'ResultWithErrorMsg.xlsx';
          a.click();
          window.URL.revokeObjectURL(url);
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('Common.Toast.Warn'),
            detail: this.translate.instant('ReceivingInstruction.BatchUpdate.ValidationFailed')
          });
        } else {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('Common.Toast.Success'),
            detail: this.translate.instant('ReceivingInstruction.BatchUpdate.UploadSuccess')
          });
          this.dialogVisibleChange(false);
          this.updateReceivingInstruction.emit({ uploadSuccess: true });
        }
      },
      error: (err) => {
        this.resetUploadState();
        console.error('Upload file error:', err);
        // 後端回傳 blob 時，錯誤 body 需要用 FileReader 解析
        if (err?.error instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result as string);
              this.messageService.add({
                severity: 'error',
                summary: this.translate.instant('Common.Toast.Error'),
                detail: errorJson?.errorMsg || errorJson?.message || this.translate.instant('ReceivingInstruction.BatchUpdate.UploadFail')
              });
            } catch {
              this.messageService.add({ 
                severity: 'error', 
                summary: this.translate.instant('Common.Toast.Error'), 
                detail: this.translate.instant('ReceivingInstruction.BatchUpdate.UploadFail') 
              });
            }
          };
          reader.readAsText(err.error);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('Common.Toast.Error'),
            detail: this.translate.instant('ReceivingInstruction.BatchUpdate.UploadFail')
          });
        }
      }
    });
  }

  // 重設上傳狀態
  resetUploadState(): void {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.isUploading = false;
    // 重置 file input 的值，讓使用者可以重新選擇相同檔案
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }
}
